import {
  okposItemUpdate, 
  // okposItemList,
  okposProxy,
  // okposUpdateMenu,
  okposItemOptionUpdate, okposItemOptionGet,
  onlItemOptionGet, onlItemOptionUpdate,
} from "../../lib/ec2-api-lib";
import { sortObjArray2, delay } from "../../lib/utils";
// import { getOnlOptionItems } from "../getOnlOptionItems";
import { parseItemOptions } from "../parseItemOptions";
import { debug } from "../../settings";

const delayTime = 500;

export async function getMasterInfo({ storeCode, setComment }) {
  try {

    const targets = [
      "PRODS",
      "SDACLCODE", "SDACDCODE",
      "SDSGRCODE", "SDSCLCODE", "SDSCDCODE",
      "CLSLMCODE", "CLSMMCODE", "CLSSMCODE",
      "TUCLSCODE",
      "TUKEYCODE",
      "TABLE"
    ]

    let errMsg = "";

    const masterInfo = {}

    for (let i = 0; i < targets.length; i++) {
      let res = await getTargetMaster({
        body: {
          'SHOP_CD': storeCode,
          'COUNT_PER_PAGE': '30',
          'CURRENT_PAGE_NUMBER': '1',
          'TARGET': targets[i]
        },
        setComment
      });
      if (res.err) {
        errMsg = `Fetching MasterInfo FAILED - ${res.err.message} at ${targets[i]}`
        break;
      }
      masterInfo[targets[i]] = res.result[targets[i]]
    }
    if (errMsg !== "") throw Error(errMsg)

    const validProdList = getValidProdList({ masterInfo })

    let mergedProds = mergeProdsTukey({ prodList: validProdList, tukeyList: masterInfo["TUKEYCODE"] })
    mergedProds = sortObjArray2({ arr: mergedProds, key: "PROD_CD" })
    masterInfo["PRODS"] = mergedProds

    return { result: { Item: masterInfo } }
  } catch (e) {
    if (debug) console.log(e)
    return { err: { message: e.message } }
  }
}

/**
 * 
 * @param {*} param.body {SHOP_CD, COUNT_PER_PAGE, CURRENT_PAGE_NUMBER, TARGET}
 * @returns 
 */
export async function getTargetMaster({ body, targetData = [], setComment, totalPages = "1", retryCnt = 0 }) {
  try {
    // 
    // delay for loop masterInfo
    // 
    await delay(delayTime)

    const targetName = body["TARGET"]

    let comment = `Receiving ${targetName} page ${body['CURRENT_PAGE_NUMBER']}`
    if (parseInt(totalPages) > 1) {
      comment += ` of total ${totalPages} pages`
    }
    if (retryCnt > 0) comment += `Retry ${retryCnt}`
    setComment(comment)

    let res = await okposProxy({ apiName: "targetMasterInfo", body });
    if (res.err) throw Error(res.err.message);

    const result = {}
    const d = res.result
    if (d.RESULT_CODE !== "0000") {

      // 
      // 요청한 페이지에 데이터가 없음  생성된 페이지 수를 넘긴 값을 요청할 경우
      // 
      if (d.RESULT_CODE === "8300") {
        result[targetName] = []
        return { result }
      }

      // 
      // retry
      // 
      if (d.RESULT_CODE === "9003") {

        if (retryCnt > 3) throw Error(getErrorMsg(res));
        return await getTargetMaster({
          body,
          targetData,
          setComment,
          totalPages,
          retryCnt: retryCnt + 1
        })
      }
      throw Error(getErrorMsg(res)); // POS res 에러 처리
    }
    const newTargetData = [...targetData, ...d.DATA[targetName]]

    if (d.CURRENT_PAGE_NUMBER !== d.TOTAL_PAGE_COUNT) {
      // await delay(delayTime)
      const newBody = {
        ...body,
        'CURRENT_PAGE_NUMBER': (parseInt(body.CURRENT_PAGE_NUMBER) + 1).toString(),
      }

      return await getTargetMaster({
        body: newBody,
        targetData: newTargetData,
        setComment,
        totalPages: d.TOTAL_PAGE_COUNT
      })
    } else {
      retryCnt = 0
      result[targetName] = newTargetData
      return { result }
    }
  } catch (e) {
    return { err: { message: e.message } }
  }
}

/**
 * prod이 SDA 혹은 SDS에 따라 또 다른 item을 사용할 경우 추가하여 리턴
 * 
 */
// function getProdsInUse({ tukey, prod, menu }) {
//   let prodsInUse = [prod]

//   if (prod["SIDE_MENU_YN"] === "Y") {

//     // 
//     // 선택
//     // 
//     if (prod["SDS_GRP_CD"] !== "") {
//       const sdsClsList = menu["SDSCLCODE"]
//       const sdsCdList = menu["SDSCDCODE"]

//       let sdsClsListForItem = sdsClsList.filter(sdsCls => sdsCls.SDS_GRP_CD === prod.SDS_GRP_CD)

//       sdsClsListForItem.map(cls => {
//         const sdsCdListForItem = sdsCdList.filter(cd => cd.SDS_CLS_CD === cls.SDS_CLS_CD)

//         const sdsProds = sdsCdListForItem.map(sdsCd => {
//           const _prods = menu.PRODS.filter(prod => prod.PROD_CD === sdsCd.PROD_CD)
//           if (_prods.length === 1) return _prods[0]
//           return null
//         })

//         prodsInUse = [...prodsInUse, ...sdsProds]
//       })
//     }
//   }
//   return prodsInUse
// }

function getValidProdList({ masterInfo }) {
  if (debug) {
    console.log("PRODS len    ", masterInfo["PRODS"]?.length)
    console.log("SDACLCODE len", masterInfo["SDACLCODE"]?.length)
    console.log("SDACDCODE len", masterInfo["SDACDCODE"]?.length)
    console.log("SDSGRCODE len", masterInfo["SDSGRCODE"]?.length)
    console.log("SDSCLCODE len", masterInfo["SDSCLCODE"]?.length)
    console.log("SDSCDCODE len", masterInfo["SDSCDCODE"]?.length)
    // console.log("CLSLMCODE len", masterInfo["CLSLMCODE"]?.length)
    // console.log("CLSMMCODE len", masterInfo["CLSMMCODE"]?.length)
    // console.log("CLSSMCODE len", masterInfo["CLSSMCODE"]?.length)
    console.log("TUCLSCODE len", masterInfo["TUCLSCODE"]?.length)
    console.log("TUKEYCODE len", masterInfo["TUKEYCODE"]?.length)
  }

  let validProdList = []

  masterInfo["TUKEYCODE"].map((tukey, i) => {

    // 
    // TUKEY로부터 prod 획득
    //
    const prods = masterInfo["PRODS"].filter(prod => tukey.PROD_CD === prod.PROD_CD)
    if (prods.length !== 1) return null


    // // 
    // // SDS list 로부터 prodInUse list 획득
    // // 
    // const prodsInUse = getProdsInUse({ tukey, prod: prods[0], menu: masterInfo })
    // validProdList = [...validProdList, ...prodsInUse]

    /** @TODO sdsCd 항목 제외 */
    validProdList.push(prods[0])

    return null
  })

  if (debug) {
    console.log('validProdList len', validProdList.length)
  }

  // 
  // validProdList 에 이미 있으면 제거
  // 
  const validProdList2 = getUniqueArray({ arr: validProdList, key: "PROD_CD" })
  if (debug) {
    console.log('validProdList2 len', validProdList2.length)
  }

  // logProdList(validProdList, validProdList2)

  return validProdList2
}

function mergeProdsTukey({ prodList, tukeyList }) {
  if (prodList.length === 0 || tukeyList.length === 0) return []
  const newPosItems = prodList.map(prod => {
    const tuListForItem = tukeyList.filter(tu => tu.PROD_CD === prod.PROD_CD)
    if (tuListForItem.length > 0) {
      prod.tuClassList = tuListForItem.map(tu => tu.TU_CLS_CD)
    } else {
      prod.tuClassList = []
    }
    return prod
  })
  return newPosItems
}

function getUniqueArray({ arr, key }) {
  const newArr = []
  arr.map(item => {
    const items = newArr.filter(newItem => newItem[key] === item[key])
    if (items.length === 0) newArr.push(item)
    return null
  })
  return newArr
}

function getErrorMsg(res) {
  let errMsg = res.result.RESULT_CODE;
  errMsg += " - " + res.result.RESULT_MSG;
  errMsg += " at " + res.result.COMMAND;
  return errMsg
}

export async function removeOptionGroupCode({ itemList, optionGroupCode }) {
  const itemsWithCode = itemList.filter(o => o.optionGroupCode === optionGroupCode)

  let errMsg = ""
  await Promise.all(itemsWithCode.map(async item => {
    let res = okposItemUpdate({
      shopId: item.shopId,
      id: item.id,
      body: { optionGroupCode: "" }
    })
    if (res.err) errMsg += res.err + " at " + item.itemCode + " update"
  }))

  if (errMsg) return { err: { message: errMsg } }
  else return {}
}

/**
 * @info cleanup onlOption.optionItemList | okposOption.TuClsList
 */
export async function cleanupOnlOptionItemList({ shopInfo, itemList, setComment }) {
  try {

    setComment(`Updating OnlItemOption...`)

    let res = await onlItemOptionGet({ shopId: shopInfo.shopId, posName: shopInfo.posName })
    if (res.err) {
      if (debug) console.log('res onlItemOptionGet', res)
      if (res.err.message === "NO ITEM FOUND") return {}
      else throw new Error(res.err.message);
    }
    // const onlItemOptions = parseItemOptionsOkpos({ itemOptions: res.result.Item })
    const onlItemOptions = parseItemOptions({ shopInfo, itemOptions: res.result.Item })

    // 
    // item 삭제 -> optionItemList에 있으면 삭제
    // 
    const newOptItemList = []
    onlItemOptions.optionItemList.map(optItem => {
      const items = itemList.filter(item => item.itemCode === optItem.itemCode)

      if (items.length === 1) newOptItemList.push({
        ...optItem,
        itemCode: items[0].itemCode,
        name: items[0].itemName,
        price: parseInt(items[0].price),
        optionPrice: parseInt(items[0].price)
      })
      return null
    })

    // 
    // 해당 optionClassList에 있으면 삭제
    // 
    const newOptClassList = onlItemOptions.optionClassList.map(optCls => {
      const newItemList = optCls.itemList.filter(code => {
        return newOptItemList.filter(item => item.itemCode === code).length === 1
      })
      return { ...optCls, itemList: newItemList }
    })

    const params = {
      shopId: shopInfo.shopId,
      posName: shopInfo.posName,
      body: {
        optionItemList: JSON.stringify(newOptItemList),
        optionClassList: JSON.stringify(newOptClassList),
      }
    }
    res = await onlItemOptionUpdate(params)
    if (res.err) throw Error(res.err.message)

    return {}
  } catch (e) {
    if (debug) console.log(e)
    return { err: { message: e.message } }
  }
}

/**
 * @info cleanup okposOption.TuClsList > itemList
 */
export async function cleanupTuClsItemList({ shopInfo, itemList, setComment }) {
  try {
    setComment(`Cleanup TuClsList itemList...`)

    let res = await okposItemOptionGet({ shopId: shopInfo.shopId })
    if (res.err) throw new Error(res.err.message);

    // const itemOptions2 = parseItemOptionsOkpos({ itemOptions: res.result.Item })
    const itemOptions2 = parseItemOptions({ shopInfo, itemOptions: res.result.Item })
    const newTuClsList0 = [...itemOptions2.TuClsList]

    const newTuClsList = makeUniqueTuClsList(newTuClsList0)

    // 
    // TuCls.itemList 에서 itemCode 삭제 | 추가
    // 
    /** 
     * @tuCls_itemCodeList_update순서_기존순서유지지
     * 1. 선행절차: mergeProdsTuKey() 함수에서 prod.tuClassList 추가 -> item.tuClassList
     * 2. for loop 에서
     *    1. preCodeList2 : preItemCodeList 에서 삭제된 item 제거
     *    2. addedItemCodeList   : item.tuClassList 에 해당하는 itemCodeList 생성
     *    3. newIemCodeList      :  
     *      3.1 preCodeList2.map -> addedItemCodeList에 있는 코드 추가
     *      3.2 addedItemCodeList.map newItemCodeList 에 없는 코드 추가
     *    4. newItemCodeListUnique itemCode 중복 제거
     * 
     * @계속_문제가_되면_menuUpdate_createTuClsList에서_처리할_것
    */
    for (let i = 0; i < newTuClsList.length; i++) {
      const key = "TU_CLS_CD"
      const tuClsCode = newTuClsList[i][key]
      const preItemCodeList = newTuClsList[i].itemList || []

      // 1. preCodeList2 : preItemCodeList 에서 삭제된 item 제거
      let preCodeList2 = preItemCodeList.filter(code => {
        return itemList.filter(item => item.itemCode === code).length > 0
      })

      // 2. item.tuClassList 에 해당하는 itemCodeList 생성
      const items = itemList.filter(item => item.tuClassList?.includes(tuClsCode))
      const addedItemCodeList = items.map(o => o.itemCode)

      // 3. addedItemCodeList에 있는 itemCode만 추가
      let newItemCodeList = []
      // 3.1 preItemCodeList 중 포함된 항목만 추가 - 시존 항목의 순서 유지를 위함
      preCodeList2.map(cd=>{
        if(addedItemCodeList.includes(cd)) newItemCodeList.push(cd)
        return null
      })

      // 3.2 포함 리스트 중  빠진 항목 추가
      addedItemCodeList.map(cd=>{
        if(!newItemCodeList.includes(cd)) newItemCodeList.push(cd)
        return null
      })


      // 4. itemCode 중복 제거
      const itemCodeListUnique = []
      newItemCodeList.map(cd => {
        if (!itemCodeListUnique.includes(cd)) itemCodeListUnique.push(cd)
        return null
      })

      newTuClsList[i].itemList = itemCodeListUnique
    }

    // console.table(newTuClsList)
    // throw Error('test 0 ....')

    res = await okposItemOptionUpdate({
      shopId: shopInfo.shopId,
      body: { TuClsList: JSON.stringify(newTuClsList) },
    })
    if (res.err) throw new Error(res.err.message);

    return {}
  } catch (e) {
    if (debug) console.log(e)
    console.log(e)
    return { err: { message: e.message } }
  }
}

function logTuClsList(itemList) {
  const names = ["TU_CLS_CD", "TU_CLS_NM", "itemList",]

  const newItemList = itemList.map(item => {
    const newItem = {}
    Object.keys(item).map(key => {
      if (names.includes(key)) newItem[key] = item[key]
      // if (key === "tuClassList") newItem[key] = JSON.stringify(item[key])
    })
    return newItem
  })
  console.table(newItemList)
}

function logProdList(validProdList, validProdList2) {

  console.log("-".repeat(30), "validProdList ", validProdList.length)
  console.table(validProdList)
  console.log("-".repeat(30), "validProdList2", validProdList2.length)

  // let addedItems = []
  // validProdList2.map(item => {
  //   if (item.SDS_CD) {
  //     addedItems.push(item)
  //   }
  //   return null
  // })


  // console.log("-".repeat(30), "addedItems    ", addedItems.length)
  // console.table(addedItems)
}

function makeUniqueTuClsList(tuClsList) {
  const newList = []

  tuClsList.map(cls => {
    const clses = newList.filter(c => c.TU_CLS_CD === cls.TU_CLS_CD)
    if (clses.length === 0) newList.push(cls)
    return null
  })

  // console.log('\n', '='.repeat(50), "TuClsList")
  // console.table(tuClsList)
  // console.table(newList)

  return newList
}
